import { render, staticRenderFns } from "./RadioBadge.vue?vue&type=template&id=61620eb5"
import script from "./RadioBadge.vue?vue&type=script&lang=js"
export * from "./RadioBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports